import { GENERAL } from '@monsido/core/constants/general.constant';

export function getSudoParams (): Record<string, string> {
    if (GENERAL.sudoRedirectUri) {
        return { redirect_uri: GENERAL.sudoRedirectUri };
    }
    return {};
}
